import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["unit", "searchInput"];

  onSearch(e) {
    e.stopPropagation();
    const searchText = this.searchInputTarget.value;

    if (searchText.length > 0) {
      this.unitTargets.forEach((element) => {
        const inputText = element.parentNode.querySelector(
          ".collection_radio_buttons"
        );
        const unitName = inputText.textContent.toLowerCase();

        if (unitName.includes(searchText.toLowerCase())) {
          element.parentNode.classList.remove("hidden");
        } else {
          element.parentNode.classList.add("hidden");
        }
      });
    } else {
      this.unitTargets.forEach((element) => {
        element.parentNode.classList.remove("hidden");
      });
    }
  }
}
